import React, {useEffect, useState} from 'react';
import {OrderSummaryDataHook} from '../../OrderSummary';
import {Dropdown, DropdownOptionProps} from 'wix-ui-tpa';
import classNames from 'clsx';
import {classes} from './DeliveryMethod.st.css';
import s from './DeliveryMethod.scss';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import {DeliverySectionModel} from '../../../../../../../domain/models/DeliverySection.model';

const getDeliverySectionLibOptions = (deliverySectionModel: DeliverySectionModel) => {
  return deliverySectionModel.options.map((option) => {
    const optionSubtitle =
      option.subtitles.length > 0
        ? option.subtitles.map((subtitle, index) => (
            <React.Fragment key={index}>
              {index > 0 && <br />}
              <span>{subtitle}</span>
            </React.Fragment>
          ))
        : undefined;

    return {
      ...option,
      subtitle: optionSubtitle,
    };
  });
};

export const DeliveryMethod = () => {
  const [dropDownKey, setDropDownKey] = useState(0);
  const {estimatedTotals} = useControllerProps().cartStore;
  const {selectShippingOption, deliverySectionModel, reportDeliveryOptionsPresented} = useControllerProps().orderStore;

  useEffect(() => {
    setDropDownKey(dropDownKey + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliverySectionModel]);

  const expandedChanged = (isExpanded: boolean) => {
    if (!isExpanded) {
      return;
    }
    reportDeliveryOptionsPresented();
  };

  return (
    <div
      className={s.root}
      data-hook={OrderSummaryDataHook.DeliveryMethodRoot}
      title={deliverySectionModel.selectedOptionTitle}>
      <dl>
        <dt className={s.dropDownContainer}>
          <Dropdown
            data-hook={OrderSummaryDataHook.DeliveryMethodDropdown}
            options={getDeliverySectionLibOptions(deliverySectionModel)}
            initialSelectedId={estimatedTotals.shippingInfo.selectedCarrierServiceOption?.code}
            upgrade={true}
            onChange={(selectedOption: DropdownOptionProps) => selectShippingOption(selectedOption.id)}
            onExpandedChange={(isExpanded: boolean) => expandedChanged(isExpanded)}
            className={classNames(classes.dropdown, s.dropDown)}
            placement={'bottom'}
            key={dropDownKey}
          />
        </dt>
      </dl>
    </div>
  );
};
